import FavoriteIcon from "@mui/icons-material/Favorite";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import type { CounterpartReactionBadgeTone } from "../utils";

export type MatchStatusPillTone = CounterpartReactionBadgeTone | "match_made";

const getStatusIcon = (tone: MatchStatusPillTone) => {
  if (tone === "match_made") {
    return (
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M11.7496 5.21038C11.7496 8.88214 6.30546 11.8542 6.07362 11.9769C6.01251 12.0098 5.9442 12.027 5.87482 12.027C5.80543 12.027 5.73712 12.0098 5.67602 11.9769C5.44417 11.8542 0 8.88214 0 5.21038C0.00097183 4.34816 0.343918 3.52153 0.9536 2.91185C1.56328 2.30217 2.38991 1.95922 3.25213 1.95825C4.3353 1.95825 5.28366 2.42404 5.87482 3.21137C6.46597 2.42404 7.41433 1.95825 8.4975 1.95825C9.35972 1.95922 10.1864 2.30217 10.796 2.91185C11.4057 3.52153 11.7487 4.34816 11.7496 5.21038Z"
          fill="#00A06D"
        />
        <path
          d="M16.0117 10.0029C16.0117 13.2364 11.2174 15.8536 11.0132 15.9617C10.9594 15.9907 10.8992 16.0058 10.8381 16.0058C10.777 16.0058 10.7169 15.9907 10.6631 15.9617C10.4589 15.8536 5.66455 13.2364 5.66455 10.0029C5.66541 9.24356 5.96742 8.5156 6.50433 7.97869C7.04124 7.44178 7.7692 7.13977 8.5285 7.13892C9.48238 7.13892 10.3175 7.54911 10.8381 8.24246C11.3587 7.54911 12.1939 7.13892 13.1478 7.13892C13.9071 7.13977 14.635 7.44178 15.1719 7.97869C15.7089 8.5156 16.0109 9.24356 16.0117 10.0029Z"
          fill="#00A06D"
        />
        <path
          d="M16.0122 10.0032C16.0115 9.33872 15.7794 8.69815 15.3618 8.18872L15.1724 7.97876C14.6355 7.44189 13.9072 7.13982 13.1479 7.13892C12.1941 7.13892 11.359 7.54916 10.8384 8.24243C10.3178 7.54915 9.48256 7.139 8.52881 7.13892C7.7695 7.13977 7.0413 7.44185 6.50439 7.97876L6.31396 8.18872C5.89651 8.69811 5.6653 9.33883 5.66455 10.0032L5.67822 10.304C5.95937 13.3964 10.4621 15.856 10.6626 15.9622C10.6894 15.9766 10.7183 15.987 10.7476 15.9944L10.8384 16.0061C10.8993 16.0061 10.9595 15.991 11.0132 15.9622C11.211 15.8574 15.7163 13.3974 15.9976 10.304L16.0122 10.0032ZM17.0122 10.0032C17.0121 12.0877 15.5008 13.809 14.2476 14.9065C12.9416 16.0502 11.6169 16.774 11.481 16.8459L11.48 16.845C11.2823 16.95 11.0623 17.0061 10.8384 17.0061C10.6139 17.0061 10.3929 16.9504 10.1948 16.845C10.0562 16.7715 8.73263 16.0488 7.42822 14.9065C6.17505 13.809 4.6647 12.0876 4.66455 10.0032V10.0022L4.66943 9.80981C4.71789 8.8556 5.11856 7.95053 5.79736 7.27173C6.52153 6.54756 7.5037 6.14007 8.52783 6.13892H8.52881C9.38137 6.13898 10.1837 6.39341 10.8374 6.86157C11.4913 6.39291 12.2948 6.13892 13.1479 6.13892H13.1489L13.3403 6.1438C14.2947 6.19214 15.2005 6.59281 15.8794 7.27173C16.6034 7.99588 17.0111 8.97818 17.0122 10.0022V10.0032Z"
          fill="white"
        />
      </svg>
    );
  }
  if (tone === "not_for_me") return <ThumbDownAltIcon />;
  if (tone === "like") return <ThumbUpAltIcon />;
  return <FavoriteIcon />;
};

export const MatchStatusPill = ({
  tone,
  label,
  className,
}: {
  tone: MatchStatusPillTone;
  label: string;
  className?: string;
}) => {
  const classes = ["matches-status-pill", `is-${tone.replace(/_/g, "-")}`];
  if (className) classes.push(className);

  return (
    <span className={classes.join(" ")}>
      <span className="matches-status-pill-icon">{getStatusIcon(tone)}</span>
      <span className="matches-status-pill-label">{label}</span>
    </span>
  );
};
